import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Leaf } from "lucide-react";
import Seo from "@/components/Seo";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const redirect = sp.get("redirect");
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const upd = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(form.name, form.email, form.password, form.phone);
    setLoading(false);
    // A fresh account is always unverified, so if we came from the cart gate, land back on
    // /verify-email (not the checkout page itself, which would just bounce them again).
    if (res.ok) nav(redirect === "/checkout" ? "/verify-email" : redirect || "/account");
  };

  return (
    <div data-testid="register-page" className="mx-auto max-w-md px-4 py-16">
      <Seo title="Create Account" path="/register" noindex={true} />
      <div className="text-center">
        <div className="mx-auto w-12 h-12 rounded-full bg-[var(--yp-primary)] text-white grid place-items-center"><Leaf /></div>
        <h1 className="font-serif-display text-3xl text-[var(--yp-primary)] mt-4">Create your account</h1>
        <p className="text-[var(--yp-muted)] text-sm">Save your plants, orders & site visits.</p>
      </div>
      <form onSubmit={submit} className="mt-8 bg-white border border-[var(--yp-border)] rounded-2xl p-6 space-y-4">
        <F id="reg-name" label="Full name" value={form.name} onChange={(v) => upd("name", v)} />
        <F id="reg-email" label="Email" type="email" value={form.email} onChange={(v) => upd("email", v)} />
        <F id="reg-phone" label="Mobile" value={form.phone} onChange={(v) => upd("phone", v.replace(/\D/g, ""))} />
        <F id="reg-password" label="Password (min 6 chars)" type="password" value={form.password} onChange={(v) => upd("password", v)} />
        <button data-testid="btn-register" disabled={loading} className="w-full btn-primary rounded-full py-3 text-sm font-medium disabled:opacity-70">
          {loading ? "Creating…" : "Create account"}
        </button>
        <div className="text-center text-sm text-[var(--yp-muted)]">
          Already have an account? <Link to="/login" data-testid="link-to-login" className="text-[var(--yp-primary)] hover:underline font-medium">Sign in</Link>
        </div>
      </form>
    </div>
  );
}

function F({ id, label, value, onChange, type = "text" }) {
  return (
    <div>
      <label className="text-xs uppercase tracking-widest text-[var(--yp-muted)]">{label}</label>
      <input data-testid={id} type={type} required value={value} onChange={(e) => onChange(e.target.value)} className="mt-1 w-full border border-[var(--yp-border)] rounded-xl px-3 py-2.5 text-sm outline-none focus:border-[var(--yp-primary)]" />
    </div>
  );
}
